export const strings = {
  new_listing: 'New Listing',
  id: 'ID',
  title: 'Title',
  description: 'Description',
  price: 'Price',
  price_to_buy: 'Price to buy',
  brand: 'Brand',
  color: 'Color',
  gender: 'Gender',
  size: 'Size',
  category: 'Category',
  for_sale: 'For sale',
  status: 'STATUS : ',
  rent_per_week: 'Rent per week',
  commission: 'Commission',
  status_sm: 'Status',
  upload: 'Select files to upload',
  productImages: 'Product Images',
  images: 'Images',
  up_to: 'up to 6',
  save_draft: 'Save Draft',
  status_draft: 'draft_by_lender',
  submit_for_approval: 'Submit for approval',
  details: 'Detail',
  return: 'Return',
  review: 'Review',
  claim: 'CLAIM',
  donate: 'DONATE',
  item_shipped: 'Item was shipped',
  withdraw_app: 'WITHDRAW APPLICATION',
  cancelListing: 'Cancel listing',
  item_received: 'Item Received',
  delete: 'Delete',
  product_details: 'Product details',
  rental_details: 'Rental details',
  returnBefore: 'Must return before: ',
  buyIt: 'Buy it!',
  problem: 'If any problems, select them below',
  selectAllProblem: 'Select all problems',
  startReturn: 'Start Return',
  productReview: 'Product review',
  feedBack: 'Feedback',
  return_note: 'Return note',
  submitReview: 'Submit Review',
  wentWrong: 'Something went wrong, please try again!',
  noProductsText: 'No products to display',
  noTransactionsText: 'No transactions to display',
  become_member: 'BECOME A MEMBER',
  listings: 'My Listings',
  profile: 'My Profile',
  add_listings: 'Add listing',
  no_product: 'No products found.',
  refresh: 'Refresh',
  no_rental: 'No rentals found.',
  no_transactions: 'No transactions found.',
  rent_more: 'Rent more items',
  rent_another: 'Rent another item',
  available_slots: 'Available rental spaces:',
  available_earnings: 'Available earnings:',
  my_rentals: 'My Rentals',
  my_earnings: 'My Earnings',
  change_photo: 'Change my photo',
  upload_photo: 'Upload my photo',
  transferCredit: 'Transfer store credit to your PayPal or Venmo account',
  paypal: 'PayPal',
  venmo: 'Venmo',
  account_id: 'Account ID:',
  email_id: 'Email:',
  amount: 'Amount $:',
  recipient_id: '(recipient id)',
  transfer: 'Transfer',
  transfer_success: 'Amount transfered successfully',
  transfer_failure: 'Amount can not exceed available earnings',
  transactions: 'Transactions',
  fit_return: 'this is a fit return',
  fit_return_info:
    'Fit return is a special return due to item size not being a good fit. If you paid extra for renting it, you can initiate and return it in 24 hours and select a new item at no extra charge.',
  orders: 'Orders',
  membership: 'Membership',
  logout: 'Logout',
  my_referrals: 'My Referrals',
  to_earn_referrals: 'To earn referral fee, give friends this link',
  no_ref_users: 'No referral users found.',
  noRefUserText: 'No referral user to display',
  refUsers: 'Earnings',
  rentalSlotText: 'Available Rental Slots',
  send: 'SEND',
  copy_link: 'Copy Link',
};
